import { render, staticRenderFns } from "./meta-watches.vue?vue&type=template&id=5e01801c"
import script from "./meta-watches.vue?vue&type=script&lang=js"
export * from "./meta-watches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports